import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../services/data.services";


const initialState = {
    loading: true,
    error: '',
    success: '',
}
export const AdminUser = createAsyncThunk('admin-user', async (searchParams) => {
    let res = await dataService.GetAPI(`admin-users/list?${(searchParams.toString())}`);
    return res
})
const adminUserSlice = createSlice({

    name: 'admin-user',
    initialState,
    reducers: {

    },
    extraReducers: {
        // register user
        [AdminUser.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [AdminUser.fulfilled]: (state, action) => {
            state.loading = false;
            if(!action?.payload?.error && action?.payload?.data?.success_status){
                state.List=action?.payload?.data;
            }else{
                state.error=action?.payload?.data?.message
            }
        },
        [AdminUser.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const {  } = adminUserSlice.actions;
export default adminUserSlice.reducer